import { FormattedMessage } from 'react-intl';
import messages from './messages';
import newTenantEventsMessages from '../NewTenantEvents/messages';
import { DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH } from '../constants';

export const HEADERS = [
  {
    id: 'headOfHousehold',
    label: <FormattedMessage {...messages.headOfHousehold} />,
    dataType: 'string',
  },
  {
    id: 'unit',
    label: <FormattedMessage {...messages.unit} />,
    dataType: 'string',
  },
  {
    id: 'hudUnitNumber',
    label: <FormattedMessage {...newTenantEventsMessages.hudUnitNumber} />,
    info: (
      <FormattedMessage {...newTenantEventsMessages.hudUnitNumberTooltip} />
    ),
    dataType: 'string',
  },
  {
    id: 'priorOrNew',
    label: <FormattedMessage {...messages.priorOrNew} />,
    dataType: 'string',
  },
  {
    id: 'newCert',
    label: <FormattedMessage {...messages.newCert} />,
    dataType: 'string',
  },
  {
    id: 'certType',
    label: <FormattedMessage {...messages.certType} />,
    dataType: 'string',
  },
  {
    id: 'effectiveDate',
    label: <FormattedMessage {...messages.effectiveDate} />,
    dataType: 'date',
  },
  {
    id: 'assistancePayment',
    label: <FormattedMessage {...messages.assistancePayment} />,
    dataType: 'number',
  },
  {
    id: 'requested',
    label: <FormattedMessage {...messages.requested} />,
    dataType: 'number',
  },
  {
    id: 'approvedAmount',
    label: <FormattedMessage {...messages.approvedAmount} />,
    dataType: 'number',
    defaultWidth: DEFAULT_APPROVED_AMOUNT_COLUMN_WIDTH,
  },
  {
    id: 'adjustmentBeginDate',
    label: <FormattedMessage {...messages.adjustmentBeginDate} />,
    dataType: 'date',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'adjustmentEndDate',
    label: <FormattedMessage {...messages.adjustmentEndDate} />,
    dataType: 'date',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'daysBeginningPartialMonth',
    label: <FormattedMessage {...messages.daysBeginningPartialMonth} />,
    dataType: 'number',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'dailyRateBeginningPartialMonth',
    label: <FormattedMessage {...messages.dailyRateBeginningPartialMonth} />,
    dataType: 'number',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'fullMonths',
    label: <FormattedMessage {...messages.fullMonths} />,
    dataType: 'number',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'fullMonthlyRate',
    label: <FormattedMessage {...messages.fullMonthlyRate} />,
    dataType: 'number',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'daysEndingPartialMonth',
    label: <FormattedMessage {...messages.daysEndingPartialMonth} />,
    dataType: 'number',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'dailyRateEndingPartialMonth',
    label: <FormattedMessage {...messages.dailyRateEndingPartialMonth} />,
    dataType: 'number',
    sx: { backgroundColor: 'primary.dark' },
  },
  {
    id: 'calculationDetailsAmount',
    label: <FormattedMessage {...messages.calculationDetailsAmount} />,
    dataType: 'number',
    sx: { backgroundColor: 'primary.dark' },
  },
];
